/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="employee.module.ts" />

module Meevo.Plugins.Employee {
    class EmployeeController extends Meevo.Components.BaseClasses.DataMaintenanceControllerBase {
        public canLocationAddUser: number = 1;
        employeeDetail: Model.DataDetail;
    // statically inject constructor resources
    static $inject = [
      "meevo.AppSettings",
      "$http",
      "meevo.components.common.DataService",
      "meevo.components.modal.ModalService",
      "meevo.components.common.IdentityService",
      "meevo.components.logging.LoggingService",
      "meevo.components.common.SecurityService",
      "meevo.components.tracking.TrackingService",
      "$rootScope",
      "$scope",
      "$state",
      "meevo.ContextParams",
      'meevo.components.short-cuts.ShortCutsService',
      "meevo.components.busy.BusyService",
      "$filter",
      "meevo.components.common.ImageGalleryService",
      "meevo.components.common.RatingsService",
      "$translate",
      "$timeout" ];

    public searchCriteria: any;

    constructor(protected appSettings: Meevo.Components.Common.IAppSettings,
      protected $http: angular.IHttpService,
      protected dataService: Meevo.Components.BaseClasses.IDataService,
      protected modalService: Meevo.Components.Modal.IModalService,
      protected identityService: Meevo.Components.Common.IIdentityService,
      protected loggingService: Meevo.Components.Logging.ILoggingService,
      protected securityService: Meevo.Components.Common.ISecurityService,
      protected trackingService: Meevo.Components.Tracking.ITrackingService,
      protected $rootScope: angular.IRootScopeService,
      protected $scope: angular.IScope,
      protected $state: any,
      protected contextParams: Meevo.IContextParams,
      protected shortCutsService: Meevo.Components.ShortCuts.IShortCutsService,
      protected busyService: Meevo.Components.Busy.IBusyService,
      protected $filter: angular.IFilterService,
      protected imageGalleryService: Meevo.Components.Common.IImageGalleryService,
      protected ratingsService: Meevo.Components.Common.IRatingsService,
      protected $translate: angular.translate.ITranslateService,
      protected $timeout: ng.ITimeoutService    ) {

            super(appSettings,
                dataService,
                modalService,
                identityService,
                loggingService,
                $scope,
                contextParams,
                $state,
                $rootScope,
                shortCutsService,
                {
                use: true,
                udfNoun: Meevo.Model.NounEnum.EmployeeUDF,
                appAreaEnum: Meevo.Model.AppAreaEnum.Employee
        });

            this.searchCriteria = {
                showEmployeesOnly: true,
                showTerminated: false,
                includeActive: true,
                includeInactive: false,
                includeDeleted: false,
                EmployeeEntityTypeEnum: Meevo.Model.EmployeeEntityTypeEnum.Employee
            };
            this.dataService.customMethodData("api/Employee/CanLocationAddMoreUser",
                    "GET",
                    '',
                    {
                        locationId: this.identityService.locationId,
                        excludeUserId: "00000000-0000-0000-0000-000000000000"
                    })
                .then(
            result => {
                        this.canLocationAddUser = result.data;
              });
        }

    createContext(): void {

      let vm = <EmployeeController>this;
      vm.busyService.start();
      vm.securityService.checkSection(vm.meevoSecurityKeys.DATA_EMPLOYEE).then(() => {
        vm.busyService.stop();
                vm.context = new EmployeeContext(this.appSettings,
                    vm.dataService,
                    vm.modalService,
                    vm.identityService,
                    vm.loggingService,
                    this.securityService,
                    vm.trackingService,
                    vm.$rootScope,
                    vm.busyService,
                    vm.customDataContextConfig,
                    vm.imageGalleryService,
                    vm.ratingsService,
                    this.$timeout,
                    vm.employeeDetail,
                    vm.$translate,
                    vm.canLocationAddUser);
          super.createContext();

        vm.context.activate(vm.selectedItemId, null, vm.asLocationId);
        vm.context.deactivate = () => {
          vm.visualState = Model.MaintenanceFormVisualState.Search;
        }
        let empContext = <EmployeeContext>vm.context;

      }).catch(() => {
        vm.busyService.stop();
      });
    }

        showTerminatedFilter = (criteria: any): void => {
            if (criteria.showTerminated) {

                criteria.includeActive = false;
                criteria.includeInactive = false;
                criteria.includeDeleted = false;

            }
        }

        employeeSearch = (search: any, criteria: any): void => {
            if (!criteria.showTerminated &&
                !criteria.includeActive &&
                !criteria.includeInactive &&
                !criteria.includeDeleted) {

                this.modalService.error("MESSAGE_INVALID_SEARCH", 0, true);

            } else {
                if (Model.Guard.isSomething(search))
                    search();
            }
        }

        clearEmpAdvancedSearch = (clearAdvancedSearch: any, criteria: any): void => {
            if (Model.Guard.isSomething(clearAdvancedSearch)) {
                criteria.showTerminated = false;
                clearAdvancedSearch();
            }
        }
        async applyParams(params) {
            await super.applyParams(params);
            if (Model.Guard.isSomething(params) && Model.Guard.isSomething(params.employeeId)) {
                // Get context
               
                let context = (<EmployeeContext>this.context);
                // Update context and rebuild sections
                if (Model.Guard.isNothing(context)) {
                   //context = new EmployeeTemplatePromotionsContext(vm.appSettings, vm.dataService, vm.modalService, vm.identityService, vm.loggingService, this.securityService, vm.trackingService, vm.$translate, vm.employeeDetail);
                }
                if (Model.Guard.isSomething(context) && this.visualState === Model.MaintenanceFormVisualState.Detail) {
                    context.employeeDetail = { id: params.employeeId };
                    context.reinitializeSetcions();
                    this.selectedItemId = params.employeeId;
                    context.activate(this.selectedItemId);
                }
                //else if (params.actionState === Model.MaintenanceFormState.Adding) {
                //    this.employeeDetail = { id: params.employeeId };
                //}
            }
        }
  }

angular.module("meevo.plugins.employee")
    .controller("meevo.plugins.employee.EmployeeController", EmployeeController);
}